import Big from 'Common/utils/customBig';

const adaptFiltersRangeResponseData = data => ({
	...data,
	irrMin: data.irrMin ? Number(Big(data.irrMin).times(100).toString()) : data.irrMin,
	irrMax: data.irrMax ? Number(Big(data.irrMax).times(100).toString()) : data.irrMax,
});

export default adaptFiltersRangeResponseData;
